/**
 *  All api related to content groups
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'


export function fetchContentGroupByCode(options = {}) {
  const { code, cancelKey = 'fetchContentGroupByCode', ...params } = options
  const source = CancelToken.source()
  cancelRequest.add(
    cancelKey,
    () => source.cancel(`${cancelKey}: Operation cancelled by user`)
  )

  return OmnitechApi
    .request({
      endpoint: `content_groups/by_code/${code}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      contentGroup: data.contentGroup
    }))
}

export function fetchContentGroup(options = {}) {
  const { id, cancelKey = 'fetchContentGroup', ...params } = options
  const source = CancelToken.source()
  cancelRequest.add(
    cancelKey,
    () => source.cancel(`${cancelKey}: Operation cancelled by user`)
  )

  return OmnitechApi
    .request({
      endpoint: `content_groups/${id}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      contentGroup: data.contentGroup
    }))
}
